import StaticContentClient from './StaticContentClient';

export class CustomStaticContentClient extends StaticContentClient {
    constructor(httpClient, baseStaticURL) {
        super(httpClient);
        this.constructor.BASE_URL = baseStaticURL;
        this.constructor.REMINDERS_URL = `${baseStaticURL}/reminders.json`;
        this.constructor.INSTRUCTIONS_URL = `${baseStaticURL}/instructions.json`;
    }
}

export default CustomStaticContentClient;
